// Lib
import loadable from 'react-loadable';

export const LoadableDebugToolbar = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "debug-toolbar" */
            './DebugToolbar'
        ),
    loading: () => null,
});

export default LoadableDebugToolbar;
